import { Button, type ButtonProps } from '@mantine/core';
import { type MouseEventHandler } from 'react';

interface PortalButtonProps extends ButtonProps {
  fullWidthMobile?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
}

export function PortalButton({ fullWidthMobile = false, style, ...props }: PortalButtonProps) {
  return (
    <Button
      {...props}
      style={{
        minHeight: 44,
        ...(typeof style === 'object' && style !== null ? style : {}),
      }}
      fullWidth={fullWidthMobile ? undefined : props.fullWidth}
      styles={theme => ({
        root: {
          ...(fullWidthMobile
            ? {
                width: '100%',
                [`@media (min-width: ${theme.breakpoints.sm})`]: {
                  width: 'auto',
                },
              }
            : {}),
        },
      })}
    />
  );
}
